var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4137 9.19434H23.9771L16.1918 18.1446L25.3512 30.3215H18.1798L12.5635 22.9353L6.1357 30.3215H2.57032L10.8979 20.7479L2.11133 9.19531H9.46481L14.5418 15.9465L20.4137 9.19434ZM19.1636 28.1769H21.138L8.3919 11.2269H6.2732L19.1636 28.1769Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXFooter);
export default __webpack_public_path__ + "static/media/x-footer.97f13f4660987d8a1c940a3cd5c6456c.svg";
export { ForwardRef as ReactComponent };